module.exports = __webpack_public_path__ + "img/Jakub.c5d74ca7.jpg";